var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBaby = function SvgBaby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M15.75 21h.018M26.25 21h.017M17.5 28c.875.525 2.1.875 3.5.875s2.625-.35 3.5-.875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M33.25 11.025a15.75 15.75 0 0 1 3.15 6.825 3.5 3.5 0 0 1 0 6.3 15.75 15.75 0 0 1-30.8 0 3.5 3.5 0 0 1 0-6.3A15.75 15.75 0 0 1 21 5.25c3.5 0 6.125 1.925 6.125 4.375S25.55 14 23.625 14c-1.4 0-2.625-.7-2.625-1.75"
  })));
};
export default SvgBaby;